/*
 *		Copyright (c) 2011-2022 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

angular.module('accessWebClient')
    .controller('PublicFolderController', [
        '$rootScope',
        '$routeParams',
        '$scope',
        'headerService',
        'PublicFolderResource',
        'RoutePaths',
        'WebPreview',
        function (
            $rootScope,
            $routeParams,
            $scope,
            headerService,
            PublicFolderResource,
            RoutePaths,
            WebPreview
        ) {
            var baseRoute = window.location.pathname;
            var rootFolder = $rootScope.rootFolder;
            var currentNodeUUID = $routeParams.uuid;

            headerService.addBreadcrumbsRootItem(rootFolder.name, null);

            $scope.currentNode = currentNodeUUID === rootFolder.uuid ? rootFolder : PublicFolderResource.get();

            $scope.table = {
                model: PublicFolderResource,
                perPage: 100,
                supportsSearch: false
            };

            $scope.currentNode.$promise
                .then(function () {
                    headerService.reset();

                    $scope.currentNode.parents.forEach(function (child) {
                        headerService.addBreadcrumbsItem(child.name, baseRoute + _getUrl(child));
                    });

                    headerService.addBreadcrumbsItem($scope.currentNode.name, baseRoute + $scope.currentNode.getUrl());
                });

            Object.defineProperties($scope, {
                // This property will be reloaded on every $digest cycle
                // TODO: Figure out a way to reload it only once on table load
                canDownload: {
                    get: function () {
                        return $scope.table.entries && $scope.table.entries.some(function (node) {
                            return node.canBeDownloaded;
                        })
                    }
                }
            });

            $scope.openPreview = function (node) {
                WebPreview.open(node, false, false);
            };

            function _getUrl(node) {
                return '#' + RoutePaths.PUBLIC_FOLDER + '/' + node.uuid;
            }
        }
    ]);
